import { useEffect, useState } from "react";

const NAV = [
  { href: "#overview", label: "全程复盘" },
  { href: "#timeline", label: "事件时间线" },
  { href: "#finale", label: "大结局" },
  { href: "#moments", label: "名场面" },
  { href: "#topics", label: "讨论区" },
  { href: "#faq", label: "常见问题" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className="sticky top-0 z-50">
      <div
        className={`transition-colors duration-300 ${
          scrolled ? "bg-background-50/90 backdrop-blur border-b border-background-200" : "bg-background-50/70"
        }`}
      >
        <div className="page-shell flex items-center justify-between py-3">
          <a href="#top" className="group flex items-center gap-2 whitespace-nowrap" aria-label="88吃瓜复盘 回到顶部">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
              <i className="ri-goblet-fill" aria-hidden="true" />
            </span>
            <span className="font-display text-2xl leading-none text-foreground-950">
              88<span className="text-primary-500">吃瓜</span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-7" aria-label="主导航">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="text-sm font-medium text-foreground-800 transition-colors hover:text-primary-500 whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="#guide"
              className="hidden sm:inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-chat-smile-3-line" aria-hidden="true" />
              补课指南
            </a>
            <button
              type="button"
              onClick={() => setOpen((v) => !v)}
              className="flex h-10 w-10 items-center justify-center rounded-full border border-background-300 text-xl text-foreground-900 lg:hidden"
              aria-label={open ? "关闭菜单" : "打开菜单"}
              aria-expanded={open}
            >
              <i className={open ? "ri-close-line" : "ri-menu-line"} aria-hidden="true" />
            </button>
          </div>
        </div>

        {open && (
          <nav
            className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3"
            aria-label="移动端菜单"
          >
            <ul className="flex flex-col">
              {NAV.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={() => setOpen(false)}
                    className="flex items-center justify-between rounded-lg px-3 py-3 text-sm font-medium text-foreground-800 hover:bg-background-100"
                  >
                    {item.label}
                    <i className="ri-arrow-right-s-line text-foreground-500" aria-hidden="true" />
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        )}
      </div>
    </header>
  );
}